import _get from 'lodash/get';
import { GIFT_TABLE_STATUS } from 'constants/giftTableStatus';

import { getProductsById } from 'services/api/products';
import { updateVariantIdGiftTable } from 'services/api/table';

export const isTableOpen = (tableInfo) =>
  _get(tableInfo, 'status', '') === GIFT_TABLE_STATUS.OPEN;

export const updateVariantIdIfChanged = async (data, params) => {
  const { table_id, product_id, variant_id, children_sku } = params;
  await Promise.all(data.map(async (p) => {
    if (p[variant_id]) {
      const product = await getProductsById([p[product_id]]);
      
      const variations = product?.data?.length ? product.data[0].variations : null;
      const isNewVariant = variations ? !variations.some(v => v.id === p[variant_id]) : false;
      const productBySku = isNewVariant ? variations.filter(v => v.sku === p[children_sku]) : [];

      if (isNewVariant && productBySku.length) {
        await updateVariantIdGiftTable(table_id, p[product_id], {
          current_variant_id: p[variant_id],
          new_variant_id: productBySku[0].id
        });
        p[variant_id] = productBySku[0].id;
      }
    }
    return p;
  }));
  return data;
};
